import { Component, Input, OnInit } from '@angular/core';

interface GlossaryEntry {
  term: string;
  description: string;
}

@Component({
    selector: 'app-glossary-search',
    templateUrl: './glossary-search.component.html',
    styleUrls: ['./glossary-search.component.scss'],
    standalone: false
})
export class GlossarySearchComponent implements OnInit {
  @Input() glossaryUrl: string;

  constructor(
  ) { }

  ngOnInit(): void {
  }
}
